module.exports = "<app-settings *ngIf=\"isAuthenticated\"></app-settings>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/app/components/settings-auth/settings-auth.component.html
// module id = ../../../../../src/app/components/settings-auth/settings-auth.component.html
// module chunks = main